import styled from 'styled-components';

export const HorizontalSeparator = styled.div`
  height: 1px;
  width: 100%;
  background-color: #d9d9d9;
`;
